import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { useEffect, useRef } from "react"
import { connect } from "react-redux"

import { updateDiamond } from "areas/product/store/actions"
import {
  ChoiceOption,
  OptionsSlider,
  OptionTitle,
} from "areas/product/wizard-options/components"
import Image from "components/ui/image"
import { useNavigation } from "helpers/use-navigation"

const ChoiceOptions = ({
  selectedStoneType,
  stoneTypeOptions,
  setChoice,
  focusElementRef,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })

  return (
    <OptionsSlider
      aria-label="Gemstone Options"
      data-slider="true"
      role="radiogroup"
    >
      {stoneTypeOptions
        .filter((s) => !s.is_diamond)
        .map((stone, i) => {
          const stoneCode = stone.value
          const selected = selectedStoneType === stoneCode
          const focused = selectedStoneType ? selected : i === 0

          return (
            <ChoiceOption
              aria-checked={selected}
              className="basis-85 shadow-none"
              data-cy={`stone-type-${stoneCode}`}
              key={`d_stone_type_${stoneCode}`}
              onClick={() => setChoice(stone)}
              role="radio"
              tabIndex={focused ? 0 : -1}
              {...(focused && { ref: focusElementRef })}
              {...keyboardProps}
            >
              <Image
                alt={stone.title}
                height="64px"
                src={`${sl.config.jewlr_asset_url}images/product/diamond/rd/${stoneCode}.png`}
                srcSet={`${`${sl.config.jewlr_asset_url}images/product/diamond/rd/${stoneCode}.png`} 1x, ${`${sl.config.jewlr_asset_url}images/product/diamond/rd/${stoneCode}_2x.png`} 2x`}
                width="64px"
              />
              <OptionTitle className="text-14 tablet:text-16 leading-16 tablet:leading-18">
                {stone.title}
              </OptionTitle>
            </ChoiceOption>
          )
        })}
    </OptionsSlider>
  )
}

ChoiceOptions.propTypes = {
  focusElementRef: PropTypes.object,
  selectedStoneType: PropTypes.string,
  setChoice: PropTypes.func,
  stoneTypeOptions: PropTypes.array,
}

const InternalChooseGemstones = ({
  selectedStoneType,
  stoneTypeOptions,
  selectedStoneTypeDescription,
  setChoice,
}) => {
  const focusElementRef = useRef()

  useEffect(() => {
    if (focusElementRef.current) {
      focusElementRef.current.focus()
    }
  }, [])

  return (
    <>
      <FocusScope>
        <ChoiceOptions
          focusElementRef={focusElementRef}
          selectedStoneType={selectedStoneType}
          setChoice={setChoice}
          stoneTypeOptions={stoneTypeOptions}
        />
      </FocusScope>
      <p className="text-15 mb-24">{selectedStoneTypeDescription}</p>
    </>
  )
}

const mapStateToProps = (state) => {
  const selectedStoneType = state.choices.d_stone_type.value
  const selectedStoneTypeDescription = state.diamondSelector[
    "d_stone_type"
  ]?.find((opt) => opt.value === selectedStoneType)?.description
  return {
    selectedStoneType,
    selectedStoneTypeDescription,
    stoneTypeOptions: state.diamondSelector.d_stone_type,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setChoice: (stone) => {
      dispatch(updateDiamond("d_stone_type", stone))
    },
  }
}

InternalChooseGemstones.propTypes = {
  selectedStoneType: PropTypes.string,
  selectedStoneTypeDescription: PropTypes.string,
  setChoice: PropTypes.func,
  stoneTypeOptions: PropTypes.array,
}

const ChooseGemstones = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalChooseGemstones)

export default ChooseGemstones
